'use strict';

window.constants = {
    // example: http://localhost:8001/api/
    "authServer": "<AUTH_SERVER_URL>",
    // example: localhost:8001/api
    "applicationServer": "<APPLICATION_SERVER_URL>",
};
